import {GenericLayout} from "../layout/GenericLayout";
import React from "react";

export const NotFoundPage = () => {
    return <GenericLayout navbar={<>&nbsp;</>}>
        <p>Not found</p>
    </GenericLayout>
}